import React from 'react';

import * as Yup from 'yup';
import {Button, Form} from 'react-bootstrap';
import {useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {yupResolver} from '@hookform/resolvers/yup';

import {ICreateUserForm} from 'users/pages/CreateUser/CreateUser';
import {FullScreenModalDescription} from 'shared/components/FullScreenModal/FullScreenModalDescription';
import { useNavigate } from 'react-router-dom';

const parentSignupFormSchema = Yup.object().shape({
    email: Yup.string().email().required(),
});

interface IPublicSignupFormProps {
    isSubmitting: boolean;
    onSubmit: (val: ICreateUserForm) => void;
}

export const PublicSignupStudentConfirm = () => {
    const [isSubmitting, setIsSubmitting] = React.useState<boolean>();
    const {t} = useTranslation();

    const navigate = useNavigate();

    const {register, handleSubmit, formState: {errors}, setError} = useForm({
        resolver: yupResolver(parentSignupFormSchema),
        defaultValues: {
            email: '',
        },
    });

    const onSubmit = () => {
        (async () => {
            try {
                setIsSubmitting(true);
                
                navigate('/login');
            } catch (error) {
                
            } finally {
                setIsSubmitting(false);
            }
        })();
    };

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <FullScreenModalDescription className="Signup--text">
                {t(
                    'publicSignupForm.clarification',
                    `To access the platform you need permission from a parent or 
                    guardian. An email will be sent to them to confirm their permission`,
                )}
            </FullScreenModalDescription>
            <Form.Group controlId="signup.email">
                <Form.Label>{t('PublicSignupStudentConfirm.emailAddress', 'Parent Email Address')}</Form.Label>
                <Form.Control
                    type="email"
                    placeholder={t('PublicSignupStudentConfirm.emailAddress', 'Parent Email Address')}
                    isInvalid={!!errors.email}
                    {...register('email')}
                />
                {(errors.email) && (
                    <Form.Control.Feedback type="invalid">
                        {errors.email.message}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
            <div className="text-center">
                <Button className="Signup--signup-button" type="submit" variant="primary" disabled={isSubmitting}>
                    {isSubmitting ? (
                        t('comoon.send', 'Sending...', {context: 'busy'})
                    ) : (
                        t('common.send', 'Send')
                    )}
                </Button>
            </div>
        </Form>
    );
};